const PLAYER_VOLUME_STORAGE_KEY = "saas-video-play-player-volume";
const DEFAULT_PLAYER_SETTINGS = {
  volume: 1,
  muted: false,
  lastVolume: 1,
};

const normalizePlayerVolume = (volume) => {
  const numericVolume = Number(volume);
  if (!Number.isFinite(numericVolume)) return 0;
  return Math.max(0, Math.min(1, numericVolume));
};

const getStorage = () => {
  if (typeof window === "undefined" || !window.localStorage) return null;
  return window.localStorage;
};

const normalizePlayerSettings = (settings = {}) => {
  const volume = normalizePlayerVolume(settings.volume);
  const lastVolume = normalizePlayerVolume(settings.lastVolume);
  const muted = Boolean(settings.muted) || volume === 0;

  return {
    volume,
    muted,
    lastVolume: lastVolume > 0 ? lastVolume : DEFAULT_PLAYER_SETTINGS.lastVolume,
  };
};

const readStoredPlayerSettings = () => {
  const storage = getStorage();
  if (!storage) return { ...DEFAULT_PLAYER_SETTINGS };
  try {
    const rawSettings = window.localStorage.getItem(PLAYER_VOLUME_STORAGE_KEY);
    if (!rawSettings) return { ...DEFAULT_PLAYER_SETTINGS };
    return normalizePlayerSettings(JSON.parse(rawSettings));
  } catch (error) {
    return { ...DEFAULT_PLAYER_SETTINGS };
  }
};

const storedPlayerSettings = readStoredPlayerSettings();
let sharedPlayerVolume = storedPlayerSettings.volume;
let sharedPlayerMuted = storedPlayerSettings.muted;
let sharedPlayerLastVolume = storedPlayerSettings.lastVolume;

const persistSharedPlayerSettings = () => {
  const storage = getStorage();
  if (!storage) return;
  try {
    window.localStorage.setItem(
      PLAYER_VOLUME_STORAGE_KEY,
      JSON.stringify({
        volume: sharedPlayerVolume,
        muted: sharedPlayerMuted,
        lastVolume: sharedPlayerLastVolume,
      })
    );
  } catch (error) {
    return;
  }
};

export function getSharedPlayerVolume() {
  return sharedPlayerMuted ? 0 : sharedPlayerVolume;
}

export function getSharedPlayerRawVolume() {
  return sharedPlayerVolume;
}

export function getSharedPlayerMuted() {
  return sharedPlayerMuted;
}

export function getSharedPlayerLastVolume() {
  return sharedPlayerLastVolume;
}

export function setSharedPlayerVolume(volume) {
  const normalizedVolume = normalizePlayerVolume(volume);
  sharedPlayerVolume = normalizedVolume;
  sharedPlayerMuted = normalizedVolume === 0;
  if (normalizedVolume > 0) {
    sharedPlayerLastVolume = normalizedVolume;
  }
  persistSharedPlayerSettings();
  return getSharedPlayerVolume();
}

export function setSharedPlayerSettings({
  volume,
  muted,
  lastVolume,
} = {}) {
  const normalizedVolume = normalizePlayerVolume(volume);
  const normalizedLastVolume = normalizePlayerVolume(lastVolume);
  sharedPlayerVolume = normalizedVolume;
  sharedPlayerMuted = Boolean(muted) || normalizedVolume === 0;
  if (normalizedLastVolume > 0) {
    sharedPlayerLastVolume = normalizedLastVolume;
  } else if (!sharedPlayerMuted && normalizedVolume > 0) {
    sharedPlayerLastVolume = normalizedVolume;
  }
  persistSharedPlayerSettings();
  return {
    volume: sharedPlayerVolume,
    muted: sharedPlayerMuted,
    lastVolume: sharedPlayerLastVolume,
  };
}
